import { object, string } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';

export default () => {
    const { REQUIRED_TEXT } = getValidationTexts();
    return object().shape({
        name: string().required(REQUIRED_TEXT).nullable(),
        panel: string().required(REQUIRED_TEXT).nullable(),
    });
};
